import { ROUTE_COMPONENTS } from "./registry";
import { HomeRedirect } from "./RouteFallbacks";

export function buildDynamicRoutes(serverData: any) {
  const routes: any[] = [];

  // Dashboard
  if (serverData.dashboard) {
    const Comp = ROUTE_COMPONENTS[serverData.dashboard.component];

    routes.push({
      index: true,
      path: "/",
      element: Comp ? <Comp /> : <div>Component Missing</div>,
    });

    // Recent Activity full page — a SUB-ROUTE of the dashboard (same pattern as
    // the gmail template routes below). Gating it on `serverData.dashboard`
    // means it inherits the dashboard's tab permission: no new Tab row, no
    // routeKey, and no access_config back-fill across existing roles.
    const ActivityComp = ROUTE_COMPONENTS["ActivityPage"];
    if (ActivityComp) {
      routes.push({ path: "activity", element: <ActivityComp /> });
    }
    // The Team members card's full view (`/insights/kf-<id>` | `/insights/country`)
    // — the same sub-route pattern, so it is reachable exactly where the card is.
    const KeyInsightsComp = ROUTE_COMPONENTS["KeyInsightsPage"];
    if (KeyInsightsComp) {
      routes.push({ path: "insights/:dimKey", element: <KeyInsightsComp /> });
    }
  } else {
    // `/` exists ONLY when the role carries the dashboard tab. Without this
    // branch a dashboard-less role has no index route at all, so the
    // post-login `navigate("/")` and every "Go Back Home" link land on the
    // catch-all — a permanent 404 with no way out. HomeRedirect forwards them
    // to the first page they can actually reach.
    routes.push({ index: true, element: <HomeRedirect /> });
  }

  if (serverData.whatsapp) {
    const Comp = ROUTE_COMPONENTS[serverData.whatsapp.component];

    routes.push({
      path: serverData.whatsapp.path,
      element: Comp ? <Comp /> : <div>Component Missing</div>,
    });
  }

  if (serverData.gmail) {
    const Comp = ROUTE_COMPONENTS[serverData.gmail.component];

    routes.push({
      path: serverData.gmail.path,
      element: Comp ? <Comp /> : <div>Component Missing</div>,
    });

    routes.push({
      path: `${serverData.gmail.path}/templates/new`,
      element: Comp ? <Comp /> : <div>Component Missing</div>,
    });

    routes.push({
      path: `${serverData.gmail.path}/templates/:templateId/edit`,
      element: Comp ? <Comp /> : <div>Component Missing</div>,
    });
  }

  // // Grouped routes
  serverData.groups?.forEach((group: any) => {
    group.routes?.forEach((route: any) => {
      const Comp = ROUTE_COMPONENTS[route.component];

      routes.push({
        path: route.path.replace(/^\/+/, ""),
        element: Comp ? (
          <Comp />
        ) : (
          <div>Component Missing: {route.component}</div>
        ),
      });
    });
  });

  return routes;
}
